import React, { useEffect, useRef, useState } from 'react';
import { useScreenshot, createFileName } from 'use-react-screenshot';
import WrapperComponent from '../../components/hoc/Wrapper-component';
import { StyledContainer, StyledContainerBlock } from '../../components/container/styled';
import { TextHeadTitle, TextTitle, TextCustom } from '../../components/text';
import { color, LINE_ADD_FRIEND_URL } from '../../resources';
import { navigateReplaceTo } from '../../utils/navigation';
import { Row, Col, Divider } from 'antd';
import { BREAKE_POINT, GUTTER_LAYOUT } from '../../resources';
import { convertStrToFormat } from '../../functions';
import line_button from '../../assets/images/line_button.png';
import screenShot from '../../assets/images/screenshot.png';
import { setGoogleAnalytics } from '../../functions/ga-react';
import { setFacebookPixel } from '../../functions/fb-react';
import { pushDataLayer } from '../../functions/gtm';
import './style.css';

const ThankYouScene = () => {
  const [thankYouData, setThankYouData] = useState(null);
  const goHome = () => {
    sessionStorage.removeItem('thankYouData');
    navigateReplaceTo({ pathname: '/' });
  };

  const getThankYouData = () => {
    try {
      const storedData = sessionStorage.getItem('thankYouData');
      return storedData ? JSON.parse(storedData) : null;
    } catch (error) {
      console.error('Error parsing session storage data:', error);
      return null;
    }
  };

  useEffect(() => {
    const thankYouData = getThankYouData();
    if (!thankYouData) {
      goHome();
    }
    setThankYouData(thankYouData);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  useEffect(() => {
    if (thankYouData && thankYouData.isThankyou === true) {
      const sendEventGoogleAnalytics = async () => {
        const ga = await setGoogleAnalytics();
        if (ga) {
          ga.event('AppleSure_ThankYou', {
            category: 'Sell Iphone Flow',
            label: 'Thank You Page',
          });
        }
      };

      const sendEventFacebookPixel = () => {
        const fb = setFacebookPixel();
        if (fb) {
          fb.event('AppleSure_ThankYou', {
            category: 'Sell Iphone Flow',
            label: 'Thank You Page',
          });
        }
      };

      sendEventGoogleAnalytics();
      sendEventFacebookPixel();
      // GTM: Thank you page — isThankyou ถูกเคลียร์ด้านล่าง จึงยิงครั้งเดียวต่อ booking (refresh ไม่ยิงซ้ำ)
      pushDataLayer('thank_you', {
        booking_type: thankYouData.bookingType || '',
        model: thankYouData.model || '',
        value: Number(thankYouData.final) || 0,
        currency: 'THB',
      });
      const updateData = { ...thankYouData, isThankyou: false };
      setThankYouData(updateData);
      sessionStorage.setItem('thankYouData', JSON.stringify(updateData));
      console.log('updateData', updateData);
    }
  }, [thankYouData]);

  if (!thankYouData) {
    return null;
  }

  const screenShotRef = useRef(null);
  const [image, takeScreenshot] = useScreenshot({
    type: 'image/jpeg',
    quality: 1.0,
  });

  const downloadImg = (image, { name = 'img', extension = 'jpg' } = {}) => {
    const a = document.createElement('a');
    a.href = image;
    a.download = createFileName(extension, name);
    a.click();
  };

  const getImage = () => {
    takeScreenshot(screenShotRef.current).then(downloadImg);
  };

  const handleClick = async () => {
    window.open(LINE_ADD_FRIEND_URL);

    const ga = await setGoogleAnalytics();
    if (ga) {
      ga.event('AppleSure_Add_Line', {
        category: 'Sell Iphone Flow',
        label: 'Add Line',
      });
    }
  };

  const data = {
    bookingId: thankYouData.bookingId || '',
    name: thankYouData.name || '',
    phone: thankYouData.phone || '',
    appointmentDate: thankYouData.appointmentDate || '',
    appointmentTime: thankYouData.appointmentTime || '',
    appointmentPlace: thankYouData.appointmentPlace || '',
    model: thankYouData.model || '',
    estimateprice: thankYouData.price ?? '',
    promotion: thankYouData.promotion ?? '',
    final: thankYouData.final ?? '',
  };

  return (
    <div>
      <StyledContainer>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0px', // เว้นบรรทัดให้พอดี
            textAlign: 'center',
            backgroundColor: '#ebeb31',
            borderRadius: '10px',
            maxWidth: 600,
            lineHeight: 1.0,
            margin: '20px auto',
            padding: '10px',
          }}
        >
          <TextCustom
            text={' จองเรียบร้อยแล้ว! 📱'}
            bold
            color={'#000000'}
            size={'25px'}
            styled={{ marginBottom: 0, padding: 0 }}
          />
          <TextCustom
            text={' แคปหน้าจอนี้และส่งมาที่ LINE'}
            bold
            color={'#000000'}
            size={'25px'}
            styled={{ marginTop: '12px', marginBottom: 0, padding: 0 }}
          />
          <TextCustom text={' @applehouseth'} bold color={'#000000'} size={'25px'} />
          <TextCustom
            text={' เพื่อยืนยันคิวหรือรับข่าวสารโปรโมชัน'}
            bold
            color={'#000000'}
            size={'25px'}
            styled={{ marginTop: '12px', marginBottom: 0, padding: 0 }}
          />
          <TextCustom
            text={'*ราคารับซื้อจริงขึ้นอยู่กับสภาพเครื่องและราคา ณ วันที่เข้ารับบริการ'}
            bold
            color={'#000000'}
            size={'18px'}
            styled={{ marginTop: '20px', lineHeight: 1.2 }}
          />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            maxWidth: 278,
            margin: '24px auto',
            gap: '24px',
            padding: '0px 40px',
          }}
        >
          <img src={screenShot} alt="Capture Screen" className="btn" onClick={getImage} />
          <img src={line_button} alt="LINE" className="btn" onClick={handleClick} />
        </div>
        <Row
          ref={screenShotRef}
          gutter={GUTTER_LAYOUT?.MAIN_CONTENT}
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
        >
          <Col {...BREAKE_POINT?.MAIN_CONTENT}>
            <StyledContainerBlock style={{ padding: '20px' }}>
              <TextTitle text={'สรุปข้อมูลการนัดหมายเพื่อรับสิทธิ์'} bold />
              <div className="space-container">
                <span className="text-title">เลขที่การจอง</span>
                <span className="text-detail">{data.bookingId}</span>
              </div>
              <div className="space-container">
                <span className="text-title">ชื่อ นามสกุล</span>
                <span className="text-detail">{data.name}</span>
              </div>
              <div className="space-container">
                <span className="text-title">เบอร์โทรศัพท์</span>
                <span className="text-detail">{data.phone}</span>
              </div>
              <div className="space-container">
                <span className="text-title">วันที่นัดหมาย</span>
                <span className="text-detail">{data.appointmentDate}</span>
              </div>
              <div className="space-container">
                <span className="text-title">เวลานัดหมาย</span>
                <span className="text-detail">{data.appointmentTime}</span>
              </div>
              <div className="space-container">
                <span className="text-title">สาขา</span>
                <span className="text-detail">{data.appointmentPlace}</span>
              </div>
              <div className="space-container">
                <span className="text-title">รุ่น</span>
                <span className="text-detail">{data.model}</span>
              </div>

              <div className="space-container">
                <span className="text-title">ราคาประเมิน</span>
                <span className="text-detail">
                  {convertStrToFormat(data.estimateprice, 'money')}
                  <span style={{ fontSize: '20px' }}> บาท</span>
                </span>
              </div>

              {data?.promotion !== 0 && data?.promotion != null && (
                <div
                  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                  <span className="text-title">ราคาโปรโมชั่น</span>
                  <span
                    className="text-detail"
                    style={{ display: 'flex', alignItems: 'center', color: '#45b4a8' }}
                  >
                    + {convertStrToFormat('+' + data?.promotion, 'money')}
                    <span style={{ fontSize: '20px', marginLeft: '4px' }}>บาท</span>
                  </span>
                </div>
              )}
              <Divider />
              <div className="space-container">
                <span className="text-title-price">ราคารับสุทธิ์</span>
                <span className="text-detail-price">
                  {convertStrToFormat(data.final, 'money')}
                  <span style={{ fontSize: '20px' }}> บาท</span>
                </span>
              </div>
            </StyledContainerBlock>
          </Col>
        </Row>
      </StyledContainer>
    </div>
  );
};

export default WrapperComponent('ThankYouScene')(ThankYouScene);
